<nb-card>
  <nb-card-header>{{ title }}</nb-card-header>
  <nb-card-body>{{ message }}</nb-card-body>
  <nb-card-footer>
    <button nbButton (click)="confirm()" status="danger">
      {{ confirmButtonText }}
    </button>
    <button nbButton (click)="cancel()" autofocus>
      {{ cancelButtonText }}
    </button>
  </nb-card-footer>
</nb-card>
